import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { GrupoDTO, GrupoResponseDTO } from '../../models/grupo.model';

@Injectable({
  providedIn: 'root',
})
export class GrupoService implements ApiInterface {
  private baseUrl = '/grupo';
  
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<GrupoResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<GrupoResponseDTO>(patch);
  }

  getGrupos(): Observable<any> {
    return this.apiService.get(this.baseUrl);
  }

  getById<T>(url: string): Observable<GrupoDTO> {
    return this.apiService.read<GrupoDTO>(url);
  }

  post<T>(url: string, data: GrupoDTO): Observable<GrupoDTO> {
    return this.apiService.create<GrupoDTO>(url, data);
  }

  put<T>(url: string, data: GrupoDTO): Observable<GrupoDTO> {
    return this.apiService.update<GrupoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  ativarOuInativar(id: number, status: boolean): Observable<string> {
    return this.apiService.updateText(`/grupo/ativarOuInativar/${id}/status/${status}`);
  }
}
